<template>
	<inertia-head title="My Referrals and Opt-ins" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 v-if="$page.props.user.is_super_sponsor==1" class="badge bg-warning text-white fs-lg">SUPER AFFILIATE</h1>
					<h1 class="fw-bold text-white mb-2">My Referrals and Opt-ins</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h3 class="block-title">My Referrals</h3>
			</div>
			<div class="block-content block-content-full">
				<!--START horizontal filters -->
				<div class="row">
					<div class="col-md-8">
						<div class="row mb-4">
							<label class="col-sm-1 col-form-label fs-sm">Show</label>
							<div class="col-sm-2">
								<select
									v-model="per_page"
									class="form-control form-control-sm"
								>
									<option
										v-for="per_page in [5, 10, 20, 50, 100]"
										:key="per_page"
										:value="per_page"
									>
										{{ per_page }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="row mb-4">
							<label class="col-sm-3 col-form-label fs-sm">Search</label>
							<div class="col-sm-9">
								<input
									v-model="query"
									type="search"
									class="form-control fs-sm form-control-sm"
									placeholder="Search referral here..."
								/>
							</div>
						</div>
					</div>
				</div>
				<!--END horizontal filters -->
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-vcenter">
						<thead>
							<tr>
								<th>#</th>
								<th>Name</th>
								<th>User ID</th>
								<th>Membership</th>
								<th>Expiry</th>
								<th>Status</th>
								<th>System</th>
							</tr>
						</thead>
						<tbody v-if="referrals && referrals.data.length > 0">
							<tr
								v-for="(referral, index) in referrals.data"
								:key="referral.counter"
							>
								<td>{{ index + referrals.from }}</td>
								<td>{{ referral.name }}</td>
								<td>{{ referral.counter }}</td>
								<td>{{ referral.membership }}</td>
								<td>{{ referral.expiry }}</td>
								<td>
									<span class="badge" :class="referral.status=='ACTIVE' ? 'bg-success' : 'bg-danger'">
										{{ referral.status }}
									</span>
								</td>
								<td>
									<span class="badge" :class="referral.system=='NEW SYSTEM' ? 'bg-warning' : 'bg-secondary'">
										{{ referral.system }}
									</span>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="7">
									<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="referrals.data.length > 0" :collections="referrals"
				/>
			</div>
		</div>
		<!-- Opt-ins -->
		<div class="block block-rounded">
			<div class="block-header border-bottom">
				<h3 class="block-title">My Opt-ins</h3>
			</div>
			<div class="block-content block-content-full">
				<!--START horizontal filters -->
				<div class="row">
					<div class="col-md-8">
						<div class="row mb-4">
							<label class="col-sm-1 col-form-label fs-sm">Show</label>
							<div class="col-sm-2">
								<select
									v-model="optin_per_page"
									class="form-control form-control-sm"
								>
									<option
										v-for="optin_per_page in [5, 10, 20, 50, 100]"
										:key="optin_per_page"
										:value="optin_per_page"
									>
										{{ optin_per_page }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="row mb-4">
							<label class="col-sm-3 col-form-label fs-sm">Search</label>
							<div class="col-sm-9">
								<input
									v-model="optin_query"
									type="search"
									class="form-control fs-sm form-control-sm"
									placeholder="Search optin here..."
								/>
							</div>
						</div>
					</div>
				</div>
				<!--END horizontal filters -->
				<div class="table-responsive">
					<table class="table table-striped table-borderless table-vcenter">
						<thead class="text-center">
							<tr>
								<th>#</th>
								<th>Name</th>
								<th>Opt-in Source</th>
								<th>Opt-in Date</th>
							</tr>
						</thead>
						<tbody v-if="optins && optins.data.length > 0" class="text-center">
							<tr v-for="(optin, index) in optins.data" :key="index">
								<td>{{ index + optins.from }}</td>
								<td>{{ optin.name }}</td>
								<td>{{ optin.source }}</td>
								<td>{{ optin.date }}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="4">
									<p class="m-2 fw-semibold text-center text-danger">NO RECORD FOUND</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="optins.data.length > 0" :collections="optins"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, watch, ref, use } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	props: {
		errors			: Object,
		flash			: Object,
		api_response	: Object,
		referrals 		: Object,
		optins 			: Object,
		filters 		: Object
	},
	setup(props) {
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const query 			= ref(props.filters.query);

		const per_page 			= ref(props.filters.per_page ?? 5);

		const optin_query 		= ref(props.filters.optin_query)

		const optin_per_page 	= ref(props.filters.optin_per_page ?? 5);

		watch(
			[query,optin_query],
			function ([value,optin_value],[old_value,old_optin_value]) {
				
				var param ={
								per_page : per_page.value
							};
				var param1 ={
								optin_per_page : optin_per_page.value
							}

				if(value!='')
				{
					param.query = value;
				}

				if(optin_value!='')
				{
					param1.optin_query = optin_value;
				}

				if(value!=old_value)
				{
					Inertia.get(
						'/member/affiliate-program/my-referrals', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['referrals', 'filters']
						}
					)
				}

				if(optin_value!=old_optin_value)
				{
					Inertia.get(
						'/member/affiliate-program/my-referrals',param1,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['optins', 'filters']
						}
					)
				}
			}
		)

		watch([per_page,optin_per_page], ([value,optin_value],[old_value,old_optin_value]) => {

			var param 	= { per_page:value };
			var param1 	= { optin_per_page:optin_value };

			if(query.value!='')
			{
				param.query = query.value;
			}

			if(optin_query.value!='')
			{
				param1.optin_query = optin_query.value;
			}

			if(value!=old_value)
			{
				Inertia.get(
					'/member/affiliate-program/my-referrals', param,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['referrals', 'filters']
					}
				)
			}

			if(optin_value!=old_optin_value)
			{
				Inertia.get(
					'/member/affiliate-program/my-referrals', param1,
					{
						// replace: true,
						preserveState: true,
						preserveScroll: true,
						only: ['optins', 'filters']
					}
				)
			}
			
		})

		return {
			query,
			per_page,
			optin_query,
			optin_per_page
		}

	},
}
</script>
